/** Shared author-facing diagnostics; only error severity blocks Flow preparation. */
import React from 'react';
import { Message, Button } from 'semantic-ui-react';
import { AVAILABLE_TRANSLATION_LANGUAGES } from '../../../constants/translations';
const languageName = code => AVAILABLE_TRANSLATION_LANGUAGES.find(item => item.value === code)?.text || code;
export default function FlowDiagnostics({ diagnostics = [], onSection }) {
  return diagnostics.filter(d => d && typeof d.message === 'string' && d.message.trim()).map((d, i) => {
    const warning = d.severity === 'warning';
    const sections = Array.isArray(d.sections) ? d.sections : [];
    return <Message visible color={warning ? 'orange' : 'red'} key={`${d.code}-${d.recordId}-${i}`}>
      <Message.Header>{warning ? 'Review this suggestion' : 'This needs fixing before the Flow is ready'}</Message.Header>
      {!!sections.length && <p><strong>Section:</strong> {sections.map(s => s.name).join(' → ')}</p>}
      {d.recordName && <strong>{d.recordName}</strong>}
      {d.lookupName && <p><strong>Lookup:</strong> {d.lookupName}</p>}
      {d.option && <p><strong>Answer option:</strong> {d.option}</p>}
      {!!d.languages?.length && <p><strong>Language:</strong> {d.languages.map(languageName).join(', ')}</p>}
      <p>{d.message}</p>
      {onSection && sections[0]?.id && <Button type="button" size="small" basic onClick={() => onSection(sections[0].id)}>Open section</Button>}
      {(d.recordId || d.code) && <details><summary>Support references</summary>
        {d.code && <p>Issue: <code>{d.code}</code></p>}
        {d.recordId && <p>Item: <code>{d.recordId}</code></p>}
        {d.lookupId && <p>Lookup: <code>{d.lookupId}</code></p>}
      </details>}
    </Message>;
  });
}
